export default __webpack_public_path__ + "static/media/factory.cd39ad25.mp4";